<template>
  <div class="flex flex-col items-center gap-10 max-w-[480px] mx-auto py-[126px] h-[calc(100vh-200px)]">
    <div class="size-12 flex items-center justify-center bg-[#D9DAFF] rounded-full">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" fill="#C6C7FF" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16ZM10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10V10.1213C13.25 10.485 13.1055 10.8338 12.8483 11.091L11.4697 12.4697C11.1768 12.7626 11.1768 13.2374 11.4697 13.5303C11.7626 13.8232 12.2374 13.8232 12.5303 13.5303L13.909 12.1517C14.4475 11.6132 14.75 10.8828 14.75 10.1213V10C14.75 8.48122 13.5188 7.25 12 7.25C10.4812 7.25 9.25 8.48122 9.25 10V10.5C9.25 10.9142 9.58579 11.25 10 11.25C10.4142 11.25 10.75 10.9142 10.75 10.5V10Z"
          fill="#3138FF" />
      </svg>
    </div>
    <div class="text-center">
      <p class="text-primary-100 font-medium text-heading tracking-negative-3">Oops! Page not found.</p>
      <p class="mt-2 text-primary-500 font-urbanist font-normal text-xl">Sorry, the page you’re looking for doesn’t
        exist. Let’s get you back on track.</p>
    </div>
    <div class="flex  items-center gap-4">
      <CtaButton variant="secondary" to="/">Back Home</CtaButton>
      <CtaButton :url="`${appRootUrl}/search`">Search Vehicles</CtaButton>
    </div>
  </div>
</template>

<script>
import CtaButton from "@/components/base/CtaButton.vue";
export default {
  name: "PageNotFoundView",
  components: {
    CtaButton
  },
  data(){
    return{
      appRootUrl:process.env.VUE_APP_RESLA_APP_ROOT_URL,
    }
  },
};
</script>